import { FC } from 'react';
import { ProTimePicker } from '../antd';
import SearchFormItem from './subpage/searchFormItem';
import SearchFormDisabled from './subpage/disabled';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';
import { TimePickerProps } from 'antd/lib/time-picker';
import { DETAULT_TIME_FORMAT } from '../constants/constant';

export interface SearchFormTimePickerProps extends BaseSearchFormItemProps {
  /** timePicker Props */
  timePickerProps?: TimePickerProps;
}
/** 时间 */
export const SearchFormTimePicker: FC<SearchFormTimePickerProps> = props => {
  const {
    timePickerProps,
    isDetail,
    form,
    isTable,
    name,
    testId,
    label,
    render,
    disabledRender,
    ...resProps
  } = props;
  return (
    <SearchFormItem
      {...resProps}
      name={name}
      test-id={`${testId}-${name}`}
      label={label}
    >
      {isDetail || (timePickerProps && timePickerProps.disabled) ? (
        <SearchFormDisabled
          name={name}
          isMoment
          form={form}
          isTable={isTable}
          format={(timePickerProps?.format as string) || DETAULT_TIME_FORMAT}
          render={render || disabledRender}
        />
      ) : (
        <ProTimePicker
          style={{ width: '100%' }}
          format={DETAULT_TIME_FORMAT}
          {...timePickerProps}
        />
      )}
    </SearchFormItem>
  );
};

SearchFormTimePicker.displayName = SearchFormItemEnum.SearchFormTimePicker;

export default SearchFormTimePicker;
